import { Blueprint } from '../../blueprint.class';
import { cleanIslandCfn } from '../../../islands/functions/clean-island.cfn';
import { ToolResult } from '../../types';

export interface CleanKitchenArgs {
	autoResize?: boolean;
	islandId?: string;
}

export const cleanKitchenTool = (blueprint: Blueprint, { autoResize = false, islandId }: CleanKitchenArgs): ToolResult => {
	const kitchen = blueprint.kitchens.getActiveVersion();
	if (!kitchen) return { success: false, error: 'No active kitchen found.' };

	const allIslands = kitchen.design.islands.children;
	if (allIslands.length === 0) return { success: false, error: 'No islands found in the kitchen.' };

	// Filter to specific island if islandId provided
	let islands = allIslands;
	if (islandId) {
		const targetIsland = allIslands.find((i) => i.id === islandId);
		if (!targetIsland) return { success: false, error: `Island '${islandId}' not found. Use list_islands to get valid island IDs.` };
		islands = [targetIsland];
	}

	const resizedIslands: string[] = [];

	// The per-island work (purge, auto-size, re-space, re-centre) lives in
	// cleanIslandCfn so the drag-and-drop commit can clean one island the same way.
	for (const island of islands) {
		const resized = cleanIslandCfn(island, { autoResize });
		if (resized !== null) resizedIslands.push(`${island.id} -> ${resized}"`);
	}

	let message = islandId
		? `Island '${islandId}' cleaned: distributed appliances.`
		: `Kitchen cleaned: distributed appliances across ${islands.length} island(s).`;
	if (resizedIslands.length > 0) {
		message += ` Auto-resized: ${resizedIslands.join(', ')}.`;
	}

	return { success: true, message };
};
